import React, { useCallback, useEffect } from 'react'
import { Chip, Grid, TextField, Checkbox, FormControlLabel} from '@material-ui/core'
import { SelecionarData } from 'components'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import useStyles from './styles'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import { useCasoService } from 'hooks/useCasoService'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export const FormBiologia = (props) => {
  const classes = useStyles()
  moment.locale('pt-br', localization)
  const { form, handleChange, exameSolicitado, listaVitima, idCaso, pendenteConfirmacao, tipoExame } = props
  const casoService = useCasoService()

  const fetchCaso = useCallback(async () => {
    if (idCaso) {
      const caso = await casoService.listarCasoAsync(idCaso)
      if (!form.descricaoCaso) {
        handleChange('descricaoCaso', caso.descricao)
      } else {
        handleChange('descricaoCaso', exameSolicitado?.descricaoCaso)
      }
    }
  }, [idCaso])

  const handleChangeIsVitimaDesconhecida =  (nome, valor) => {
    handleChange('isVitimaDesconhecida', valor)

    if(valor){
      handleChange('vitima', null)
    }
  }

  useEffect(() => {
    fetchCaso()
  }, [fetchCaso])

  const optionsBase = ['NÃO', 'INCERTO', 'NÃO SE APLICA']
  const optionsConjuncao = [...optionsBase, 'ANAL', 'VAGINAL', 'ORAL']
  const optionsAtos = [...optionsBase, 'MORDIDA', 'LAMBIDA']
  const optionsConcurso = [...optionsBase, '1 PESSOA', '2 PESSOAS', '3 PESSOAS', '4 PESSOAS', '5 OU MAIS PESSOAS']
  const optionsConjuncaoConsentida = ['NÃO HOUVE', 'NÃO SABE INFORMAR', 'NÃO SE APLICA']
  const optionsSim = ['SIM', ...optionsBase]

  return (
    !pendenteConfirmacao && (
      <>
        <Grid item md={6} sm={6} xs={12}>
          <Autocomplete
            name="vitima"
            disabled={form.isVitimaDesconhecida}
            value={form.vitima}
            noOptionsText="Sem informações"
            options={listaVitima || []}
            onChange={(event, newValue) => handleChange('vitima', newValue)}
            getOptionLabel={(option) => {
              if (Object.prototype.hasOwnProperty.call(option, 'nic')) return `CADÁVER - Nome: ${option.nome ? option.nome?.toUpperCase() : 'NÃO IDENTIFICADO'} - NIC: ${option.nic ? option.nic : 'NÃO INFORMADO'}`
              if (Object.prototype.hasOwnProperty.call(option, 'cpf')) return `PERICIANDO - ${option.nome ? `Nome: ${option.nome}` : `Alcunha: ${option.alcunha}` || 'NÃO INFORMADO'} - CPF: ${option.cpf || 'NÃO INFORMADO'}`
            }}
            renderOption={(option) => {
              if (Object.prototype.hasOwnProperty.call(option, 'nic')) return `CADÁVER - Nome: ${option.nome ? option.nome?.toUpperCase() : 'NÃO IDENTIFICADO'} - NIC: ${option.nic ? option.nic : 'NÃO INFORMADO'}`
              if (Object.prototype.hasOwnProperty.call(option, 'cpf')) return `PERICIANDO - ${option.nome ? `Nome: ${option.nome}` : `Alcunha: ${option.alcunha}` || 'NÃO INFORMADO'} - CPF: ${option.cpf || 'NÃO INFORMADO'}`
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="VÍTIMA"
                required={!form.isVitimaDesconhecida}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>

        <Grid item md={6} sm={6} xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{
                    marginRight: 8,
                  }}
                  checked={form.isVitimaDesconhecida}
                  onChange={(event, newValue) => handleChangeIsVitimaDesconhecida('isVitimaDesconhecida', newValue)}
              />
            }
            label="Vítima desconhecida"
          />
        </Grid>

        {tipoExame.cod === 'ESPERMATOSOIDE_PSA' && (
          <Grid item md={6} sm={6} xs={12}>
            <TextField
              label="EXAME SEXOLÓGICO"
              name="exameSexologico"
              className={classes.input}
              variant="outlined"
              value={form.exameSexologico}
              onChange={(event) => {
                handleChange('exameSexologico', event.target.value)
              }}
              fullWidth
              placeholder="UN-FFFF-0000"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        )}
        {!pendenteConfirmacao && (
          <>
            <Grid item md={6} sm={6} xs={12}>
              <SelecionarData withoutTime dataBD={form.dataColeta} callback={(data) => handleChange('dataColeta', data)} label="DATA DA COLETA" required shrink md={12} sm={12} xs={12} />
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <TextField
                label="HORA DA COLETA"
                name="horaColeta"
                variant="outlined"
                value={form.horaColeta}
                onChange={(event) => {
                  handleChange('horaColeta', event.target.value)
                }}
                required
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </>
        )}
        {tipoExame.cod === 'ESPERMATOSOIDE_PSA' && (
          <>
            <Grid item md={6} sm={6} xs={12}>
              <FreeSoloCreateOption label="DATA DO FATO" name="dataFato" value={form.dataFato} handleChange={handleChange} options={['INCERTA', 'NÃO SE APLICA']} required placeholder="dd/mm/aaaa" />
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <TextField
                label="HORA DO FATO"
                name="horaFato"
                variant="outlined"
                value={form.horaFato}
                onChange={(event) => {
                  handleChange('horaFato', event.target.value)
                }}
                required
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <FreeSoloCreateOption label="VIOLÊNCIA COMETIDA POR UMA OU MAIS PESSOAS?" name="concursoPessoas" value={form.concursoPessoas} handleChange={handleChange} options={optionsConcurso} required />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <FreeSoloCreateOption label="HOUVE CONJUNÇÃO CARNAL?" name="conjuncaoCarnal" value={form.conjuncaoCarnal} handleChange={handleChange} options={optionsConjuncao} multiple required />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <FreeSoloCreateOption label="HOUVE USO DE PRESERVATIVO?" name="usoPreservativo" value={form.usoPreservativo} handleChange={handleChange} options={optionsSim} required />
            </Grid>

            <Grid item md={6} sm={6} xs={12}>
              <FreeSoloCreateOption label="REALIZOU HIGIENE ÍNTIMA APÓS O ATO?" name="realizouHigiene" value={form.realizouHigiene} handleChange={handleChange} options={optionsSim} required />
            </Grid>
          </>
        )}
        {['PESQUISA_SANGUE_HUMANO', 'MATERIAL_CAPILAR_HUMANO'].includes(tipoExame.cod) && (
          <Grid item md={6} sm={6} xs={12}>
            <FreeSoloCreateOption label="VESTÍGIO COLETADO EM LOCAL DE CRIME?" name="coletadoEmLocal" value={form.coletadoEmLocal} handleChange={handleChange} options={optionsSim} required />
          </Grid>
        )}
        {tipoExame.cod === 'PESQUISA_SANGUE_HUMANO' && (
          <Grid item md={6} sm={6} xs={12}>
            <FreeSoloCreateOption label="APLICAÇÃO DE LUMINOL NO VESTÍGIO ANTES DA COLETA?" name="usoLuminol" value={form.usoLuminol} handleChange={handleChange} options={optionsSim} required />
          </Grid>
        )}
        {tipoExame.cod === 'MATERIAL_CAPILAR_HUMANO' && (
          <Grid item md={6} sm={6} xs={12}>
            <FreeSoloCreateOption label="VESTÍGIO COLETADO DIRETAMENTE DA VÍTIMA/SUSPEITO?" name="coletadoDiretamente" value={form.coletadoDiretamente} handleChange={handleChange} options={optionsSim} required />
          </Grid>
        )}
        <Grid item md={6} sm={6} xs={12}>
          <TextField
            label="OBSERVAÇÕES"
            name="outraObservacoes"
            value={form.outraObservacoes}
            onChange={(event) => handleChange('outraObservacoes', event.target.value)}
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </>
    )
  )
}

const filter = createFilterOptions()

const FreeSoloCreateOption = (props) => {
  const { label, name, value, handleChange, options, multiple } = props
  const classes = useStyles()
  return (
    <Autocomplete
      value={value}
      multiple={multiple}
      fullWidth
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
          handleChange(name, newValue)
        } else if (newValue && newValue.inputValue) {
          handleChange(name, newValue.inputValue)
        } else {
          handleChange(name, newValue)
        }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params)

        const { inputValue } = params
        const isExisting = options.some((option) => inputValue === option)
        if (inputValue !== '' && !isExisting) {
          filtered.push({
            inputValue,
            title: `Selecione "${inputValue.toUpperCase()}"`,
          })
        }

        return filtered
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id={name}
      options={options}
      renderValue={(value, getItemProps) =>
        value.map((option, index) => {
          const { key, ...itemProps } = getItemProps({ index })
          return <Chip variant="outlined" label={option} key={key} {...itemProps} />
        })
      }
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
          return option
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.title
        }
        // Regular option
        return option
      }}
      freeSolo
      renderInput={(params) => (
        <TextField
          {...props}
          {...params}
          label={label}
          variant="outlined"
          className={classes.input}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  )
}
